import {merge} from 'lodash';

const setInitialDeltaCustomersData = (state, payload = {}) => {
  const {delta_customers} = payload;
  if (delta_customers) {
    const oldDeltaCustomers = {...state};
    const newDeltaCustomers = {...delta_customers};
    const updatedState = merge(oldDeltaCustomers, newDeltaCustomers);
    return {...updatedState};
  } else return state;
};

export default (state = {}, action = {}) => {
  const {payload = {}} = action;
  return setInitialDeltaCustomersData(state, payload);
};
